import PropTypes from 'prop-types';
import {InferPropTypes} from '../util/type.utils';

/**
 * A heading for a section within an application with theme-able padding.
 * Similar to `ddk.SectionTitle`, but with different styling.
 *
 * **Usage**
 * ```
 * ddk._SectionHeading(title="Overview", subtitle="A high level look at the last quarter.")
 * ddk._SectionHeading(title="Overview")
 * ```
 */
export function _SectionHeading({
    title = '',
    subtitle = '',
}: InferPropTypes<typeof _SectionHeading.propTypes>) {
    return (
        <div className="ddk-exclude section-heading">
            <h2 className="section-heading-title">{title}</h2>
            <p className="section-heading-subtitle">{subtitle}</p>
        </div>
    );
}

_SectionHeading.propTypes = {
    /**
     * Text to display as the section's title.
     */
    title: PropTypes.string,
    /**
     * Text to display as the section's subtitle.
     */
    subtitle: PropTypes.string,
};
